export default __webpack_public_path__ + "static/media/dcfcWired.b4bdf5e3.svg";